<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-large-plus"
    title="エクストラサイト設定(Type1、イントラネットFW)"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer
        v-slot="{ handleSubmit }"
        :initial-values="{ addressList: extraData.addressList }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <v-row>
                  <v-col cols="5">
                    <app-badge
                      :item="extraSite === null ? '新規サイト名' : 'サイト名'"
                      :isRequired="true"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      placement="end"
                    />
                    <validation-provider
                      name="siteName"
                      label="サイト名"
                      v-model="extraData.siteName"
                      :rules="{ max: { length: 20 }, required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :error-messages="errorMessage"
                        :field-meta="meta"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <app-badge
                      item="アドレス名"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :isRequired="false"
                      placement="end"
                    />
                  </v-col>
                  <v-col cols="4">
                    <app-badge
                      item="アドレス"
                      :msg="
                        $filter.message(
                          'info_cidr_ip_address_of_network_address',
                          {
                            ipaddress1: '192.168.0.0/24',
                            genre: 'アドレス',
                            subnet1: '1',
                            subnet2: '30',
                            ipaddress2: '192.168.0.1/32',
                          }
                        )
                      "
                      :isRequired="
                        hasCheckZone ||
                        hasInputIpAddressName ||
                        extraData.addressList.length !== 1 ||
                        hasCheckIsDeploy
                      "
                      placement="end"
                    />
                  </v-col>
                  <v-col>
                    <app-badge
                      item="ゾーン配置"
                      :isRequired="false"
                      :isInfo="false"
                    />
                  </v-col>
                </v-row>
                <validation-array
                  name="addressList"
                  v-slot="{ fields, push, remove }"
                >
                  <template v-for="(item, index) in fields" :key="item.key">
                    <v-row>
                      <v-col cols="5">
                        <validation-provider
                          label="アドレス名"
                          :name="`ipAddressName_${item.key}`"
                          v-model="extraData.addressList[index].ipAddressName"
                          :rules="{ max: { length: 20 } }"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="4">
                        <validation-provider
                          label="アドレス"
                          :name="`ipAddress_${item.key}`"
                          :rules="{
                            required:
                              !!extraData.addressList[index].ipAddressName ||
                              extraData.addressList[index].zoneId !== null ||
                              extraData.addressList.length !== 1 ||
                              extraData.addressList[index].isDeploy,
                            is_ip_subnet: { min: 1, max: 32, exclude: [31] },
                            is_not_current_ip: true,
                            is_not_loopback_ip: true,
                            is_not_multicast_ip: true,
                            is_not_class_e_ip: true,
                            is_not_broadcast_ip: true,
                            is_network_address: true,
                            duplicate: { list: existsAddress(index) },
                          }"
                          v-model="extraData.addressList[index].ipAddress"
                          v-slot="{ componentField, errorMessage, meta }"
                        >
                          <app-form-input
                            :placeholder="
                              $filter.message(
                                'placeholder_ip_address_of_private_network_address'
                              )
                            "
                            v-bind="componentField"
                            :error-messages="errorMessage"
                            :field-meta="meta"
                          />
                        </validation-provider>
                      </v-col>
                      <v-col cols="2">
                        <v-checkbox
                          v-model="extraData.addressList[index].zoneId"
                          :value="extraZoneId"
                          :false-value="null"
                        />
                      </v-col>
                      <v-col
                        cols="1"
                        v-if="!extraData.addressList[index].isDeploy"
                      >
                        <v-btn
                          icon="$mdiMinus"
                          size="small"
                          variant="outlined"
                          class="rounded-sm"
                          @click="removeIPAddress(index, remove)"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <v-row justify="end">
                    <v-col cols="1">
                      <v-btn
                        icon="$mdiPlus"
                        size="small"
                        variant="outlined"
                        class="rounded-sm"
                        @click="addIPAddress(push)"
                      />
                    </v-col>
                  </v-row>
                </validation-array>
              </v-container>
            </div>
            <!-- 関連項目チェック：ゾーン配置をチェックする場合ゾーンが存在すること -->
            <cross-validation-provider
              v-if="extraData.addressList"
              :passed="noExtraZone"
              vid="noExtraZone"
              class="my-4"
            >
              エクストラゾーンが存在しません。設定してから配置してください。
            </cross-validation-provider>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">{{
                  extraSite === null ? "追加" : "変更"
                }}</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel">
                  キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  PutType1InternetAddress,
  Type1ExtraSiteModify,
  Type1ExtraSiteRegister,
  Type1SiteEdit,
  Type1Zone,
} from "@/apis/Type1SiteApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "ExtraSiteEdit",
  props: {
    extraSite: {
      type: Object as PropType<Type1SiteEdit | null>,
      default: null,
    },
    extraZone: {
      type: Object as PropType<Type1Zone | null>,
      default: null,
    },
    type1SiteZoneKeyId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      /** 詳細データ */
      extraData: {} as Type1SiteEdit,
      extraZoneId: this.extraZone?.zoneId || "none",
      isLoaded: false,
    };
  },
  computed: {
    /** 既存のIPアドレス */
    existsAddress() {
      // 既存のアドレスリストに同じIPアドレスが存在した場合はエラーとする
      return (index: number) => {
        return this.extraData.addressList
          .filter((_, num) => num !== index)
          .map((v) => v.ipAddress);
      };
    },
    /** 関連項目チェック:zoneがnull場合ゾーン配置をチェック */
    noExtraZone(): boolean {
      return !this.extraData.addressList.some((item) => item.zoneId === "none");
    },
    /** アドレス名入力済みの場合は,true */
    hasInputIpAddressName(): boolean {
      return this.extraData.addressList.some((v) => v.ipAddressName);
    },
    /** ゾーン配置チェック済みの場合は,true */
    hasCheckZone(): boolean {
      return this.extraData.addressList.some((v) => v.zoneId);
    },
    hasCheckIsDeploy(): boolean {
      return this.extraData.addressList.some((v) => v.isDeploy);
    },
  },

  mounted() {
    this.load();
    this.isLoaded = true;
  },

  methods: {
    /**
     * 初期化機能
     * システム上の配置状態追加(addressList)
     */
    load() {
      // 追加モードdefault値の設定
      if (this.extraSite === null) {
        this.extraData = {
          siteId: null,
          siteName: "",
          addressTotal: 0,
          addressList: [
            {
              ipAddressId: null,
              ipAddressName: "",
              ipAddress: "",
              zoneId: null,
              isDeploy: false,
            },
          ],
        };
      } else {
        // 変更モード値のコピー
        const data: PutType1InternetAddress[] = this.extraSite.addressList.map(
          (e) => ({
            ...e,
            isDeploy: !!e.zoneId,
          })
        );
        this.extraData = Object.assign({}, this.extraSite);
        this.extraData.addressList = data;
        if (this.extraData.addressList.length < 1)
          this.extraData.addressList.push({
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            zoneId: null,
            isDeploy: false,
          });
      }
    },
    /** 追加、変更機能 */
    async submit() {
      if (this.extraData.siteId) {
        // 変更機能
        await this.$confirm(
          "エクストラサイト設定を変更します。よろしいですか？"
        );
        // 変更データの設定
        const reqData: Type1ExtraSiteModify = {
          siteName: this.extraData.siteName,
          addressList:
            this.extraData.addressList.length === 1 &&
            !this.extraData.addressList[0].ipAddress
              ? []
              : this.extraData.addressList.map((e) => ({
                  ipAddressId: e.ipAddressId,
                  ipAddressName: e.ipAddressName || null,
                  ipAddress: e.ipAddress,
                  zoneId: e.zoneId,
                })),
          type1SiteZoneKeyId: this.type1SiteZoneKeyId,
        };
        await this.$api.type1SiteZone.postType1ExtraSiteModify(
          reqData,
          this.extraData.siteId
        );
      } else {
        // 追加機能
        await this.$confirm("エクストラサイトを追加します。よろしいですか？");
        // 追加データの設定
        const reqData: Type1ExtraSiteRegister = {
          siteName: this.extraData.siteName,
          addressList:
            this.extraData.addressList.length === 1 &&
            !this.extraData.addressList[0].ipAddress
              ? []
              : this.extraData.addressList.map((e) => ({
                  ipAddressName: e.ipAddressName || null,
                  ipAddress: e.ipAddress,
                  zoneId: e.zoneId,
                })),
          type1SiteZoneKeyId: this.type1SiteZoneKeyId,
        };
        await this.$api.type1SiteZone.postType1ExtraSiteRegister(reqData);
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * IPAddress追加機能
     * 押下時一行追加
     */
    addIPAddress(push: (item: any) => void) {
      const addItem = {
        ipAddressId: null,
        ipAddressName: "",
        ipAddress: "",
        zoneId: null,
        isDeploy: false,
      };
      this.extraData.addressList.push(addItem);
      push(addItem);
    },
    /**
     * IPAddress削除機能
     * 押下時その行削除
     * 一行しかない場合その行クリア
     */
    removeIPAddress(index: number, remove: (idx: number) => void) {
      if (this.extraData.addressList.length > 1) {
        this.extraData.addressList.splice(index, 1);
        remove(index);
      } else {
        this.extraData.addressList = [
          {
            ipAddressId: null,
            ipAddressName: "",
            ipAddress: "",
            zoneId: null,
            isDeploy: false,
          },
        ];
      }
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-input--density-default) {
  --v-input-control-height: 40px;
}
.modal-body {
  min-height: 55vh;
}
</style>
